export default __webpack_public_path__ + "static/media/0.6162f28d.png";